import { Icon, IconProps } from "./Icon";

export function IconWifi(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M11.99 19.03a1 1 0 1 0 0 2 1 1 0 1 0 0-2zm11.3-9.64A15.47 15.47 0 0 0 12 4 15.51 15.51 0 0 0 .71 9.39L0 8.69A16.35 16.35 0 0 1 12 3a16.35 16.35 0 0 1 12 5.69ZM20 12.68A11.12 11.12 0 0 0 12 9a11.12 11.12 0 0 0-8 3.66l.7.7A10.2 10.2 0 0 1 12 10a10.21 10.21 0 0 1 7.29 3.35Zm-4 4A5.85 5.85 0 0 0 12 15a5.91 5.91 0 0 0-4 1.66l.7.7A4.93 4.93 0 0 1 12 16a4.91 4.91 0 0 1 3.29 1.36Z" />
    </Icon>
  );
}
